module.exports = __webpack_public_path__ + "img/25x25_sari.8578906b.gif";